
export const getPrimaryContactName = (accountInformation) => {
    if (accountInformation && accountInformation.primaryContact && accountInformation.accountType && accountInformation.accountType.name === 'RESIDENTIAL') {
        return accountInformation.primaryContact.firstName;
    }else if(accountInformation && accountInformation.primaryContact && accountInformation.primaryContact.company !== '' && accountInformation.accountType && accountInformation.accountType.name === 'BUSINESS' ){
        return accountInformation.primaryContact.company;

} else if(accountInformation && accountInformation.primaryContact && accountInformation.primaryContact.company === '' && accountInformation.accountType && accountInformation.accountType.name === 'BUSINESS' ) {
        return accountInformation.primaryContact.name;
    } else if(accountInformation && accountInformation.account && accountInformation.account.accountType === 'RESIDENTIAL'  ){
        return accountInformation.account.name
    }
    else if(accountInformation && accountInformation.account && accountInformation.account.accountType === 'BUSINESS' && accountInformation.account.company !== '' ) {
        return accountInformation.account.company;
    } else if (accountInformation && accountInformation.account && accountInformation.account.accountType === 'BUSINESS' && accountInformation.account.company === '') {
        return accountInformation.account.name;
    } else {
        return '';
    }
}


export const getPrimaryContactCardName = (accountInformation) => {
    if (accountInformation && accountInformation.primaryContact && accountInformation.accountType && accountInformation.accountType.name === 'RESIDENTIAL') {
        return accountInformation.primaryContact.firstName + ' ' + accountInformation.primaryContact.lastName;
    }else if(accountInformation && accountInformation.primaryContact && accountInformation.primaryContact.company !== '' && accountInformation.accountType && accountInformation.accountType.name === 'BUSINESS' ){
        return accountInformation.primaryContact.company;

    } else if(accountInformation && accountInformation.primaryContact && accountInformation.primaryContact.company === '' && accountInformation.accountType && accountInformation.accountType.name === 'BUSINESS' ) {
        return accountInformation.primaryContact.name;
    } else if(accountInformation && accountInformation.accountInfo && accountInformation.accountInfo.accountType === 'Residential'  ){
        return accountInformation.accountInfo.contactName
    }
    else if(accountInformation && accountInformation.accountInfo && accountInformation.accountInfo.accountType === 'Business' && accountInformation.accountInfo.companyName !== '' ) {
        return accountInformation.accountInfo.companyName;
    } else if (accountInformation && accountInformation.accountInfo && accountInformation.accountInfo.accountType === 'Business' && accountInformation.account.company === '') {
        return accountInformation.accountInfo.contactName;
    } else {
        return '';
    }
}


export const getAccountTitleName = (accountInformation) => {
    if (accountInformation && accountInformation.primaryContact && accountInformation.accountType && accountInformation.accountType.name === 'RESIDENTIAL') {
        return `${accountInformation.primaryContact.firstName} ${accountInformation.primaryContact.lastName} ${accountInformation.accountType.name}`
    }else if(accountInformation && accountInformation.primaryContact && accountInformation.primaryContact.company !== '' && accountInformation.accountType && accountInformation.accountType.name === 'BUSINESS' ){
        return accountInformation.primaryContact.company;

    } else if(accountInformation && accountInformation.primaryContact && accountInformation.primaryContact.company === '' && accountInformation.accountType && accountInformation.accountType.name === 'BUSINESS' ) {
        return accountInformation.primaryContact.name;
    } else if(accountInformation && accountInformation.account && accountInformation.account.accountType === 'RESIDENTIAL'  ){
        return accountInformation.account.name
    }
    else if(accountInformation && accountInformation.account && accountInformation.account.accountType === 'BUSINESS' && accountInformation.account.company !== '' ) {
        return accountInformation.account.company;
    } else if (accountInformation && accountInformation.account && accountInformation.account.accountType === 'BUSINESS' && accountInformation.account.company === '') {
        return accountInformation.account.name;
    } else {
        return '';
    }
}

export const getAddress = (accountInformation) => {
    if (accountInformation && accountInformation.accountInfo && accountInformation.accountInfo.primaryContactAddress) {
        return `${accountInformation.accountInfo.primaryContactAddress.address1}`
            + (accountInformation.accountInfo.primaryContactAddress.address2 ? ', ' + `${accountInformation.accountInfo.primaryContactAddress.address2}` : '')
            + (accountInformation.accountInfo.primaryContactAddress.address3 ? ', ' + `${accountInformation.accountInfo.primaryContactAddress.address3}` : '')
            + ', ' + `${accountInformation.accountInfo.primaryContactAddress.city}`
            + ', ' + `${accountInformation.accountInfo.primaryContactAddress.systemState.abbreviation}`
            + ' ' + `${accountInformation.accountInfo.primaryContactAddress.zipcode}`;
    } else if (accountInformation && accountInformation.primaryContact && accountInformation.primaryContact.contactAddresses[0]) {
        return `${accountInformation.primaryContact.contactAddresses[0].address1}`
            + (accountInformation.primaryContact.contactAddresses[0].address2 ? ', ' + `${accountInformation.primaryContact.contactAddresses[0].address2}` : '')
            + (accountInformation.primaryContact.contactAddresses[0].address3 ? ', ' + `${accountInformation.primaryContact.contactAddresses[0].address3}` : '')
            + ', ' + `${accountInformation.primaryContact.contactAddresses[0].city}`
            + ', ' + `${accountInformation.primaryContact.contactAddresses[0].state.abbreviation}`
            + ' ' + `${accountInformation.primaryContact.contactAddresses[0].zipcode}`;
    } else {
        return 'Loading...';
    }
}

export const getAccountNumber = (accountInformation) => {
    let accountNumber = '';
    let accountType = '';

    if (accountInformation) {
        if (accountInformation.accountInfo) {
            accountNumber = accountInformation.accountInfo.accountNumber;
            accountType = accountInformation.accountInfo.accountType;
        } else if (accountInformation.number) {
            accountNumber = accountInformation.number;
            accountType = accountInformation.accountType.name
        }
    }

    if (accountNumber) {
        return `Account # ${accountNumber} - ${accountType.toUpperCase()}`;
    } else {
        return '';
    }
}

export const getStatus = (accountInformation) => {
    let status = '';
    if (accountInformation.status) {
        status = accountInformation.status;
    } else if (accountInformation.accountInfo && accountInformation.accountInfo.accountStatus) {
        status = accountInformation.accountInfo.accountStatus;
    }

    if (status) {
        return {
            status: status,
            className: 'text-success'
        };
    } else {
        return {
            status: '',
            className: 'text-danger'
        };
    }
}

export const getPanelPayments = (accountInformation) => {
    if(accountInformation.accountInfo) {
        return accountInformation.accountInfo
    } else {
        return accountInformation
    }
}

export const getPanelInvoices = (accountInformation) => {
    if(accountInformation.accountInfo) {
        return accountInformation.accountInfo
    } else {
        return accountInformation
    }
}

export const getPanelMakePayments = (accountInformation) => {
    if(accountInformation.accountInfo) {
        return accountInformation.accountInfo
    } else {
        return accountInformation
    }
}